import React, { ReactChild, ReactFragment } from "react";
import styled from "styled-components";
import { Text } from "./Text";
import { style } from "./style";

const Container = styled.div`
  padding-bottom: ${style.vars.whitespace.regular};

  &:not(:last-of-type) {
    border-bottom: ${style.vars.borderWidth.thin} solid ${style.colors.grey.light};
    margin-bottom: ${style.vars.whitespace.large};
  }
`;

export const DetailsHeading = styled(Text).attrs({ type: "h5" })``;

type Props = {
  children: ReactChild | ReactFragment;
  className?: string;
  innerRef?: React.MutableRefObject<any>;
};

export const DetailsSection: React.FC<Props> = ({ children, className, innerRef }) => {
  return (
    <Container className={className} ref={innerRef}>
      {children}
    </Container>
  );
};
